import routerOptions0 from "/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/node_modules/.pnpm/nuxt@3.15.4_@parcel+watcher@2.5.1_@types+node@22.13.4_db0@0.2.4_eslint@10.2.1_jiti@2.4.2__ior_f573ykspucr5i56m45vmcehyxm/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}